export default __webpack_public_path__ + "static/media/imgWave.bd572ce6.png";